export const Constants = {
  TAG_NAME: 'pop-example-usage-component',
} as const;
